import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const CTAButton = ({ children, href = "#contact", testId, className = "", onClick }) => {
  const handleClick = (e) => {
    if (onClick) return onClick(e);
    if (href === "#contact") {
      e.preventDefault();
      window.dispatchEvent(new CustomEvent("open-discovery"));
    }
  };
  return (
    <motion.a
      href={href}
      onClick={handleClick}
      data-testid={testId}
      whileTap={{ scale: 0.97 }}
      className={`inline-flex items-center justify-center gap-2 rounded-full bg-brand px-7 py-3.5 text-sm font-semibold text-ink-950 transition-colors hover:bg-brand-hover shadow-[0_0_30px_rgba(140,198,63,0.28)] ${className}`}
    >
      {children}
    </motion.a>
  );
};

export const GhostButton = ({ children, href = "#framework", testId, className = "" }) => (
  <a
    href={href}
    data-testid={testId}
    className={`inline-flex items-center justify-center gap-2 rounded-full border border-line px-7 py-3.5 text-sm font-semibold text-[#3d4436] transition-colors hover:border-brand/60 hover:text-[#23271F] ${className}`}
  >
    {children}
  </a>
);

export const SectionLabel = ({ children }) => (
  <span className="overline">{children}</span>
);
